import { useRequiredParams } from '@pba/react-router';
import { CommunityAssets, CommunityLayout } from 'features/communities';

type RouteParams = {
  communityId: string;
};

const PageCommunityAssets = () => {
  const { communityId } = useRequiredParams<RouteParams>();

  return (
    <CommunityLayout communityId={communityId} tab="/assets">
      {(community) => <CommunityAssets community={community} />}
    </CommunityLayout>
  );
};

export default PageCommunityAssets;
